export default Object.freeze({
  SendGrid: 1,
  Smtp: 2,
});
